import { ThemeTonalRange } from '@philips-emr/tws-constants';
import { ThemeService } from '@philips-emr/tws-core/lib/services';

import BaseController from './BaseController';

export default class NoLoginBaseController extends BaseController {
  noLoginThemeSetUp(): void {
    const dsLoginTonalRange = ThemeTonalRange.ULTRA_LIGHT;
    ThemeService.setContentTonalRange(dsLoginTonalRange);
  }

}
